import { Component, ViewChild, ApplicationRef } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { Content } from 'ionic-angular';
import { dmHotel } from '../sign-in/xv-hotel';
import { DocsViewModel } from './xv-docs';
import { MLText, mlBroker } from '../../services/MLText';
import { AppDataBroker } from '../../services/AppData';
import { SignInPage } from '../sign-in/sign-in';
import { dmLoading } from '../loading/loading';


@Component({
    selector: 'page-docs'
    , templateUrl: 'docs.html'
})
export class DocsPage {
    @ViewChild(Content) content: Content;

    Docs: DocsViewModel;
    ShowAlert: (pTitle: string, pMessage: string) => void;
    NewLoading: (pMessage: string) => dmLoading;
    ShowConfirmation: (pTitle: string, pMessage: string, pAction: () => void) => void;
    ScrollToBottom: () => void;
    BackToSignIn: () => void;

    app: mlBroker;

    Application: ApplicationRef;

    constructor(
        public navCtrl: NavController
        , public alertCtrl: AlertController
        , public loadingCtrl: LoadingController
        , public mlText: MLText
        , public appDataBroker: AppDataBroker
        , public applicationRef: ApplicationRef       
    ) {
        let hotel = appDataBroker.GetAppData() as dmHotel;

        this.app = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );

        this.Application = applicationRef;

        this.ShowAlert = (pTitle: string, pMessage: string) => {
            let alert = this.alertCtrl.create({
                title: pTitle
                , message: pMessage
                , buttons: [
                    {
                        text: this.app.Text('OK')
                        , handler: () => { return true; }
                    }
                ]
            });

            alert.present();
        };

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                , () => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.ShowConfirmation = (
            pTitle: string
            , pMessage: string
            , pAction: () => void
        ) => {
            let alert = this.alertCtrl.create({
                title: pTitle
                , message: pMessage
                , buttons: [
                    {
                        text: this.app.Text('Cancel')
                        , role: 'cancel'
                        , handler: () => { return true; }
                    }
                    , {
                        text: this.app.Text('OK')
                        , handler: () => { pAction(); return true; }
                    }
                ]
            });

            alert.present();
        };

        this.ScrollToBottom = () => {
            if (this.content) {
                this.Application.tick();

                this.content.scrollToBottom(0);
            }
        };

        this.BackToSignIn = () => {
            this.navCtrl.setRoot(SignInPage);
        };

        this.Docs= new  DocsViewModel(
            mlText
            , hotel
            , this.BackToSignIn
            , this.ShowAlert
            , this.NewLoading
            , this.ShowConfirmation
            , this.ScrollToBottom
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/docs/docs.ts